// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"84d5d5fc","452":"0d1ae2ca"}[chunkId] + ".chunk.css";
};